module.exports = {
        srcSet: __webpack_public_path__ + "static/media/digital_address_mobile-639.62a42c47.webp"+" 639w",
        images: [{path: __webpack_public_path__ + "static/media/digital_address_mobile-639.62a42c47.webp",width: 639,height: 426}],
        src: __webpack_public_path__ + "static/media/digital_address_mobile-639.62a42c47.webp",
        toString: function(){return __webpack_public_path__ + "static/media/digital_address_mobile-639.62a42c47.webp"},
        
        width: 639,
        height: 426
      }